module.exports = __webpack_public_path__ + "static/scale-model-of-nipsey-hussle-mural-(oakland)-in-oakland-california-b7a5cb335730d93139ab945ba4a33839.png";